import axios from '../base/axios';
import API_KEY from './key';

const GET_TVKIDS = 'flixfrenzy/redux/GET_TVKIDS';

// eslint-disable-next-line default-param-last
const tvKidsReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVKIDS:
      return action.payload;
    default:
      return state;
  }
};

export const getTvKids = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10762`).then((res) => {
    dispatch({
      type: GET_TVKIDS,
      payload: res.data,
    });
  });
};

export default tvKidsReducer;
